import React, { useState, useEffect, useContext, useMemo } from "react";
import { AuthContext } from "../../../contexts/AuthContext";
import Header from "../../../layout/Header/Header";
// import Footer from "../../layout/Footer/Footer";
import {
  Button,
  Row,
  Table,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Input,
  Label,
  ButtonGroup,
  Col,
  Spinner,
} from "reactstrap";
import SweetAlert from "sweetalert2-react";
import Swal from "sweetalert2";
import { jsPDF } from "jspdf";
import "jspdf-autotable";
import autoTable from "jspdf-autotable";
import ExportJsonExcel from "js-export-excel";
import encode from "nodejs-base64-encode";
import axios from "axios";
import BajaAltaMultiple from "../../BajaAltaMultiple";
import { TableHeader, Pagination, Search } from "../../../DataTable";
import useFullPageLoader from "../../../hooks/useFullPageLoader";
import { v4 as uuidv4 } from "uuid";
import qrcode from "qrcode-js";
import moment from "moment";

function AnalisisGeneralProductos() {
  const { user } = useContext(AuthContext);
  const URL_ARTICULOS_SURTIDOS = process.env.REACT_APP_URL_ARTICULOS_SURTIDOS;
  const URL_CLIENTES = process.env.REACT_APP_URL_CLIENTES;
  const URL_MARCAS = process.env.REACT_APP_URL_MARCAS;
  const URL_SEND_MAIL_ATT = process.env.REACT_APP_URL_SEND_MAIL_ATT;

  let hoy = new Date();
  let inicio = new Date();
  inicio.setDate(inicio.getDate() - 30);

  let endDate = moment(hoy).format("YYYY-MM-DD");
  let startDate = moment(inicio).format("YYYY-MM-DD");

  const [clientes, setClientes] = useState([]);
  const [selectedCliente, setSelectedCliente] = useState("");

  const [marcas, setMarcas] = useState([]);
  const [selectedMarca, setSelectedMarca] = useState("");

  const [totalTotalCantidad, setTotalTotalCantidad] = useState(0);
  const [totalTotalCantidadEntregado, setTotalTotalCantidadEntregado] = useState(0);
  const [totalTotalCantidadPorEntregar, setTotalTotalCantidadPorEntregar] = useState(0);
  const [totalTotalDinero, setTotalTotalDinero] = useState(0);
    const [totalTotalDineroBruto, setTotalTotalDineroBruto] = useState(0);

  const [selectedFechaInicio, setSelectedFechaInicio] = useState("");
  const [selectedFechaFin, setSelectedFechaFin] = useState("");

  const [selectedFechaInicio2, setSelectedFechaInicio2] = useState("");
  const [selectedFechaFin2, setSelectedFechaFin2] = useState("");

  const [mesesPeriodo1, setMesesPeriodo1] = useState(0);
const [mesesPeriodo2, setMesesPeriodo2] = useState(0);

  const [modalMail, setModalMail] = useState(false);
  const toggleMail = () => setModalMail(!modalMail);
  const [mailTo, setMailTo] = useState("");

  const [cargando, setCargando] = useState(false);
    const [fechaModificada, setFechaModificada] = useState(false);


  const [activo, setActivo] = useState("");

  //--- Pagination
  const [comments, setComments] = useState([]);
  const [loader, showLoader, hideLoader] = useFullPageLoader();
  const [totalItems, setTotalItems] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [search, setSearch] = useState("");
  const [sorting, setSorting] = useState({ field: "", order: "" });

  const ITEMS_PER_PAGE = 50;

  const Toast = Swal.mixin({
    toast: true,
    position: "center",
    showConfirmButton: false,
    // timer: 5000,
    timerProgressBar: true,
    didOpen: (toast) => {
      toast.addEventListener("mouseenter", Swal.stopTimer);
      toast.addEventListener("mouseleave", Swal.resumeTimer);
    },
  });

  if (cargando) {
    Toast.fire({
      html: `<i class="fas fa-hourglass-half custom-spin fa-2x" style="margin-right: 16px;"></i>`, // Ícono de carga animado
      title: "Danos unos segundos....",
      customClass: {
        icon: 'animated-icon'
      }
    });
  }

  useEffect(() => {
    const meses1 = calcularMeses(selectedFechaInicio, selectedFechaFin);
  const meses2 = calcularMeses(selectedFechaInicio2, selectedFechaFin2);
  setMesesPeriodo1(meses1);
  setMesesPeriodo2(meses2);

    // axios
    //   .get(`${URL_ARTICULOS_SURTIDOS}AnalisisGeneralProductos/${selectedFechaInicio}/${selectedFechaFin}/${selectedFechaInicio2}/${selectedFechaFin2}`, {
    //     headers: {
    //       Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
    //     },
    //   })
    //   .then((response) => {
    //     let allVentas = response.data;
    //     // Array para pagination
    //     let arrayTabla = allVentas
    //       // .sort((a, b) => (a.idVentas > b.idVentas ? 1 : -1))
    //       .map((a) => {
    //         return {
    //           SKU: a.articulos[0].SKU,
    //           nombre: a.articulos[0].nombre,
    //           marca: a.articulos[0].marcas[0].name,
    //           idMarca: a.articulos[0].marcas[0]._id,

    //           cantidadPeriodo1: a.CantidadPeriodo1,
    //           precioPromedioBrutoPeriodo1: a.PrecioPromedioBrutoPeriodo1,
    //           precioPromedioNetoPeriodo1: a.PrecioPromedioNetoPeriodo1,
    //           margenBrutoPeriodo1: a.MargenBrutoPeriodo1,

    //           cantidadPeriodo2: a.CantidadPeriodo2,
    //           precioPromedioBrutoPeriodo2: a.PrecioPromedioBrutoPeriodo2,
    //           precioPromedioNetoPeriodo2: a.PrecioPromedioNetoPeriodo2,
    //           margenBrutoPeriodo2: a.MargenBrutoPeriodo2,
    //         };
    //       })
    //       .filter(function (el) {
    //         return el != null;
    //       });

    //     let dataFinal = Object.values(arrayTabla);

        
    
    //     setComments(dataFinal);

    //     setCargando(false);
    //     setFechaModificada(false); // ✅ Regresa color azul
    //     Toast.close();

    //   })
    //   .catch((err) => {
    //     console.log(err);
    //   });

      axios
        .get(URL_MARCAS, {
          headers: {
            Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
          },
        })
        .then((response) => {
          let allMarcas = response.data;
          setMarcas(allMarcas);
        })
        .catch((err) => {
          console.log(err);
        });

  }, [selectedFechaInicio, selectedFechaFin, selectedFechaInicio2, selectedFechaFin2]);



  function BuscaInfo(){
        const meses1 = calcularMeses(selectedFechaInicio, selectedFechaFin);
  const meses2 = calcularMeses(selectedFechaInicio2, selectedFechaFin2);
  setMesesPeriodo1(meses1);
  setMesesPeriodo2(meses2);
  
    setComments([])
    setCargando(true)
    axios
    .get(`${URL_ARTICULOS_SURTIDOS}AnalisisGeneralProductos/${selectedFechaInicio}/${selectedFechaFin}/${selectedFechaInicio2}/${selectedFechaFin2}`, {
      headers: {
        Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
      },
    })
    .then((response) => {
      let allVentas = response.data;
      // Array para pagination
      let arrayTabla = allVentas
        // .sort((a, b) => (a.idVentas > b.idVentas ? 1 : -1))
        .map((a) => {
            return {
              SKU: a.ArticuloCompleto?.SKU || "",
              nombre: a.ArticuloCompleto?.nombre || "",
              marca: a.ArticuloCompleto?.marcas?.[0]?.name || "",
              idMarca: a.ArticuloCompleto?.marcas?.[0]?._id || "",

              cantidadPeriodo1: a.CantidadPeriodo1,
              precioPromedioBrutoPeriodo1: a.PrecioPromedioBrutoPeriodo1,
              precioPromedioNetoPeriodo1: a.PrecioPromedioNetoPeriodo1,
              margenBrutoPeriodo1: a.MargenBrutoPeriodo1,

              cantidadPeriodo2: a.CantidadPeriodo2,
              precioPromedioBrutoPeriodo2: a.PrecioPromedioBrutoPeriodo2,
              precioPromedioNetoPeriodo2: a.PrecioPromedioNetoPeriodo2,
              margenBrutoPeriodo2: a.MargenBrutoPeriodo2,

              disponible: a.disponible,
              inventarioMeli: a.inventarioMeli,
              inventarioAmazon: a.inventarioAmazon,
              porRecibir: a.porRecibir,

              ventaUltimos30Dias: a.ventaUltimos30Dias,
              precioPromedioNeto30Dias: a.precioPromedioNeto30Dias
            };
          })
          .filter(function (el) {
            return el != null;
          });

        let dataFinal = Object.values(arrayTabla);

        
    
        setComments(dataFinal);

      setCargando(false);
      setFechaModificada(false); // ✅ Regresa color azul
      Toast.close();
    })
    .catch((err) => {
      console.log(err);
    });
  }

    const calcularMeses = (fechaInicio, fechaFin) => {
  const inicio = moment(fechaInicio);
  const fin = moment(fechaFin);
  const diff = fin.diff(inicio, "months", true); // con decimales
  return Math.max(1, Math.round(diff)); // mínimo 1 mes
};
function excel() {
  const dataExcel = commentsData.map((a) => {
    if (selectedMarca === "" || selectedMarca === a.idMarca) {
      const totalStock = a.inventarioMeli + a.inventarioAmazon + a.disponible;
      const promedioMensual1 = a.cantidadPeriodo1 / mesesPeriodo1 || 0;
      const promedioMensual2 = a.cantidadPeriodo2 / mesesPeriodo2 || 0;
      const variacionVentas =
        promedioMensual1 > 0
          ? ((promedioMensual2 - promedioMensual1) / promedioMensual1)
          : null;
      const variacionPrecio =
        a.precioPromedioBrutoPeriodo1 > 0
          ? ((a.precioPromedioBrutoPeriodo2 - a.precioPromedioBrutoPeriodo1) / a.precioPromedioBrutoPeriodo1)
          : null;
      const mesesInventario =
        promedioMensual2 > 0 ? totalStock / promedioMensual2 : null;

      const margen = a.margenBrutoPeriodo2 || 0;

      const precioSugerido = ""; // vacía
      const ingresoNeto = ""; // cálculo depende del valor manual
      const comentarios = "";
      const precioAutorizadoElias = "";
      const ingresoNeto2 = "";
      const comentariosElias = "";

      return {
        SKU: a.SKU,
        nombre: a.nombre,
        cantidadPeriodo1: a.cantidadPeriodo1,
        precioPromedioBrutoPeriodo1: a.precioPromedioBrutoPeriodo1.toFixed(2),
        promedioVentasMensualesPeriodo1: promedioMensual1.toFixed(2),
        cantidadPeriodo2: a.cantidadPeriodo2,
        precioPromedioBrutoPeriodo2: a.precioPromedioBrutoPeriodo2.toFixed(2),
        promedioVentasMensualesPeriodo2: promedioMensual2.toFixed(2),
        precioPromedioNetoPeriodo2: a.precioPromedioNetoPeriodo2.toFixed(2),
        margenBrutoPeriodo2: margen.toFixed(2),
        variacionVentas: variacionVentas !== null ? (variacionVentas * 100).toFixed(2) + "%" : "N/A",
        variacionPrecio: variacionPrecio !== null ? (variacionPrecio * 100).toFixed(2) + "%" : "N/A",
        inventarioMeli: a.inventarioMeli,
        inventarioAmazon: a.inventarioAmazon,
        disponible: a.disponible,
        totalStock: totalStock,
        porRecibir: a.porRecibir,
        mesesInventario: mesesInventario !== null ? mesesInventario.toFixed(2) : "N/A",
        ventaUltimos30Dias: a.ventaUltimos30Dias,
        precioPromedioNeto30Dias: a.precioPromedioNeto30Dias.toFixed(2),

        // Nuevas columnas
        precioSugerido,
        ingresoNeto,
        comentarios,
        precioAutorizadoElias,
        ingresoNeto2,
        comentariosElias,
      };
    }
  });

  const dataExportExcel = dataExcel.filter((el) => el != null);

  const option = {
    fileName: "AnalisisGeneralProductos",
    datas: [
      {
        sheetData: dataExportExcel,
        sheetName: "AnalisisGeneralProductos",
        sheetFilter: [
          "SKU",
          "nombre",
          "cantidadPeriodo1",
          "precioPromedioBrutoPeriodo1",
          "promedioVentasMensualesPeriodo1",
          "cantidadPeriodo2",
          "precioPromedioBrutoPeriodo2",
          "promedioVentasMensualesPeriodo2",
          "precioPromedioNetoPeriodo2",
          "margenBrutoPeriodo2",
          "variacionVentas",
          "variacionPrecio",
          "inventarioMeli",
          "inventarioAmazon",
          "disponible",
          "totalStock",
          "porRecibir",
          "mesesInventario",
          "ventaUltimos30Dias",
          "precioPromedioNeto30Dias",

          // Nuevas columnas
          "precioSugerido",
          "ingresoNeto",
          "comentarios",
          "precioAutorizadoElias",
          "ingresoNeto2",
          "comentariosElias",
        ],
        sheetHeader: [
          "SKU",
          "Nombre",
          "Ventas Unidades Periodo 1",
          "Precio Bruto Promedio Periodo 1",
          "Promedio Ventas Mensuales Periodo 1",
          "Ventas Unidades Periodo 2",
          "Precio Bruto Promedio Periodo 2",
          "Promedio Ventas Mensuales Periodo 2",
          "Precio Neto Promedio Periodo 2",
          "Margen Bruto Periodo 2",
          "Variacion Ventas",
          "Variacion Precio",
          "Total Stock FULL",
          "Total Stock FBA",
          "Stock Disponible Libre",
          "Total Stock",
          "Pend de Recibir",
          "Meses de Inventario",
          "Venta Ultimos 30 Dias",
          "Promedio Neto Ultimos 30 Dias",

          // Nuevos encabezados
          "Precio Sugerido",
          "Ingreso Neto",
          "Comentarios",
          "Precio Autorizado Elias",
          "Ingreso Neto 2",
          "Comentarios Elias",
        ],
      },
    ],
  };

  const toExcel = new ExportJsonExcel(option);
  toExcel.saveExcel();
}



// console.log("hola", comments)
  const headers = [
    { name: "SKU", field: "SKU", sortable: true },
    { name: "Nombre", field: "nombre", sortable: true },

    { name: "Ventas Unidades Periodo 1", field: "cantidadPeriodo1", sortable: true },
    { name: "Precio Bruto Promedio Periodo 1", field: "precioPromedioBrutoPeriodo1", sortable: true },
    { name: "Promedio Ventas Mensuales Periodo 1", field: "promedioVentasMensualesPeriodo1", sortable: false },

    { name: "Ventas Unidades Periodo 2", field: "cantidadPeriodo2", sortable: true },
    { name: "Precio Bruto Promedio Periodo 2", field: "precioPromedioBrutoPeriodo2", sortable: true },
    { name: "Promedio Ventas Mensuales Periodo 2", field: "promedioVentasMensualesPeriodo2", sortable: false },
    { name: "Precio Neto Promedio Periodo 2", field: "precioPromedioNetoPeriodo2", sortable: true },
    { name: "Margen Bruto Periodo 2", field: "margenBrutoPeriodo2", sortable: true },

    { name: "Variacion Ventas", field: "variacionVentas", sortable: false },
    { name: "Variacion Precio", field: "variacionPrecio", sortable: false },


    { name: "Total Stock FULL", field: "inventarioMeli", sortable: true },
    { name: "Total Stock FBA", field: "inventarioAmazon", sortable: true },
    { name: "Stock Disponible Libre", field: "disponible", sortable: true },
    { name: "Total Stock", field: "totalStock", sortable: false },
    { name: "Pend de Recibir", field: "porRecibir", sortable: true },

    { name: "Meses de Inventario", field: "mesesInventario", sortable: false },

    { name: "Venta Ultimos 30 Dias", field: "ventaUltimos30Dias", sortable: true },
    { name: "Promedio Neto Ultimos 30 Dias", field: "precioPromedioNeto30Dias", sortable: true },



    
  ];


  const commentsData = useMemo(() => {
    let computedComments = comments;

    if (search) {
      computedComments = computedComments.filter(
        (comment) =>
          comment.SKU.toLowerCase().includes(search.toLowerCase()) ||
        comment.nombre.toLowerCase().includes(search.toLowerCase()) ||
        comment.marca.toLowerCase().includes(search.toLowerCase()) ||
          comment.cantidadPeriodo1.toString().includes(search) ||
          comment.precioPromedioBrutoPeriodo1.toString().includes(search) ||
          // comment.promedioVentasMensualesPeriodo1.toString().includes(search) ||
          comment.cantidadPeriodo2.toString().includes(search) ||
          comment.precioPromedioBrutoPeriodo2.toString().includes(search) ||
          // comment.promedioVentasMensualesPeriodo2.toString().includes(search) ||
          comment.precioPromedioNetoPeriodo2.toString().includes(search) ||
          comment.margenBrutoPeriodo2.toString().includes(search) ||
          // comment.veriacionVentas.toString().includes(search) ||
          // comment.veriacionPrecio.toString().includes(search)||
          comment.inventarioMeli.toString().includes(search) ||
          comment.inventarioAmazon.toString().includes(search) ||
          comment.disponible.toString().includes(search) ||
          comment.porRecibir.toString().includes(search)
      );
    }

    if (selectedMarca) {
      computedComments = computedComments.filter((e) =>
        e.idMarca.includes(selectedMarca)
      );
    }

    setTotalItems(computedComments.length);

    // let cant = computedComments.map((c) => parseFloat(c.cantidad));
    // let Tcant = cant.reduce((t, cantidad, index) => t + cantidad, 0);
    // setTotalTotalCantidad(Tcant);

    //Sorting comments
    if (
      sorting.field &&
      sorting.field != "cantidadPeriodo1" &&
      sorting.field != "precioPromedioBrutoPeriodo1" &&
      sorting.field != "cantidadPeriodo2" &&
      sorting.field != "precioPromedioBrutoPeriodo2" &&
      sorting.field != "margenBrutoPeriodo2" &&
      sorting.field != "inventarioMeli" &&
      sorting.field != "inventarioAmazon" &&
      sorting.field != "disponible" &&
      sorting.field != "porRecibir"
    ) {
      const reversed = sorting.order === "asc" ? 1 : -1;
      computedComments = computedComments.sort(
        (a, b) => reversed * a[sorting.field].localeCompare(b[sorting.field])
      );
    }

    if (
      sorting.field &&
      sorting.order === "asc" &&
      (
        sorting.field == "cantidadPeriodo1" ||
        sorting.field == "precioPromedioBrutoPeriodo1" ||
        sorting.field == "cantidadPeriodo2" ||
        sorting.field == "precioPromedioBrutoPeriodo2" ||
        sorting.field == "margenBrutoPeriodo2" ||
        sorting.field == "inventarioMeli" ||
        sorting.field == "inventarioAmazon" ||
        sorting.field == "disponible" ||
        sorting.field == "porRecibir"
      )
    ) {
      computedComments = computedComments.sort((a, b) =>
        parseFloat(a[sorting.field]) > parseFloat(b[sorting.field]) ? 1 : -1
      );
    }

    if (
      sorting.field &&
      sorting.order === "desc" &&
      (
         sorting.field == "cantidadPeriodo1" ||
        sorting.field == "precioPromedioBrutoPeriodo1" ||
        sorting.field == "cantidadPeriodo2" ||
        sorting.field == "precioPromedioBrutoPeriodo2" ||
        sorting.field == "margenBrutoPeriodo2" ||
        sorting.field == "inventarioMeli" ||
        sorting.field == "inventarioAmazon" ||
        sorting.field == "disponible" ||
        sorting.field == "porRecibir"
      )
    ) {
      computedComments = computedComments.sort((a, b) =>
        parseFloat(a[sorting.field]) < parseFloat(b[sorting.field]) ? 1 : -1
      );
    }

    //Current Page slice
    return computedComments.slice(
      (currentPage - 1) * ITEMS_PER_PAGE,
      (currentPage - 1) * ITEMS_PER_PAGE + ITEMS_PER_PAGE
    );
  }, [
    comments,
    currentPage,
    search,
    sorting,
    // selectedCliente,
    selectedMarca,
  ]);


  return (
    <>
      <Header />
      <br />
      <br />
      {user.menu_ventas ? (
        <div className="card col-12">
          <Row>
            <Col md={8}>
              <Button
                size="sm"
                href="/MenuVentas"
                className="btn btn-danger"
                id="botonListado"
              >
                Regresar
              </Button>
            </Col>
            <Col sm={4}>
              <ButtonGroup id="logoutBoton">
                {/* <Button
                  size="sm"
                  className="btn"
                  color="danger"
                  onClick={PDFTabla}
                >
                  PDF <i class="far fa-file-pdf"></i>
                </Button>
                <Button
                  size="sm"
                  className="btn"
                  onClick={toggleMail}
                  color="info"
                >
                  eMail <i class="fas fa-at"></i>
                </Button> */}
                <Button
                  size="sm"
                  className="btn"
                  color="primary"
                  onClick={excel}
                >
                  Excel <i class="far fa-file-excel"></i>
                </Button>
              </ButtonGroup>
            </Col>
          </Row>
          {/* <Modal size="sm" isOpen={modalMail} toggle={toggleMail}>
            <ModalHeader toggle={toggleMail}>
              <h4>Enviar Reporte Ventas Articulo Agrupado</h4>
            </ModalHeader>
            <ModalBody>
              <Label className="mr-sm-2">Email</Label>
              <Input
                className="col-sm-12"
                type="text"
                value={mailTo}
                required
                onChange={(e) => {
                  setMailTo(e.target.value);
                }}
              />
            </ModalBody>
            <ModalFooter>
              <Button size="sm" color="success" onClick={enviaMail}>
                Enviar
              </Button>
            </ModalFooter>
          </Modal> */}
          <h3 align="center">Analisis General Productos</h3>
          <div className="row">
            <div className="col-md-8">
              <Pagination
                total={totalItems}
                itemsPerPage={ITEMS_PER_PAGE}
                currentPage={currentPage}
                onPageChange={(page) => setCurrentPage(page)}
              />
            </div>
            <div className="col-md-4 d-flex flex-row-reverse">
              <Search
                onSearch={(value) => {
                  setSearch(value);
                  setCurrentPage(1);
                }}
              />
            </div>
          </div>
          <br />
          <Row>
            <Col md={2}>
              <Label className="mr-sm-2">Fecha Inicio</Label>
              <Input
                bsSize="sm"
                type="date"
                value={selectedFechaInicio}
                required
                onChange={(e) => {
                  setSelectedFechaInicio(e.target.value);
                  setFechaModificada(true);
                }}
              />
            </Col>
            <Col md={2}>
              <Label className="mr-sm-2">Fecha Fin</Label>
              <Input
                bsSize="sm"
                type="date"
                value={selectedFechaFin}
                required
                onChange={(e) => {
                  setSelectedFechaFin(e.target.value);
                  setFechaModificada(true);
                }}
              />
            </Col>
             <Col md={1}>
              <Label className="mr-sm-2">Meses Periodo 1</Label>
              <Input
                bsSize="sm"
                type="number"
                value={mesesPeriodo1}
                disabled
              />
            </Col>
             <Col md={2}>
              <Label className="mr-sm-2">Fecha Inicio 2</Label>
              <Input
                bsSize="sm"
                type="date"
                value={selectedFechaInicio2}
                required
                onChange={(e) => {
                  setSelectedFechaInicio2(e.target.value);
                  setFechaModificada(true);
                }}
              />
            </Col>
            <Col md={2}>
              <Label className="mr-sm-2">Fecha Fin 2</Label>
              <Input
                bsSize="sm"
                type="date"
                value={selectedFechaFin2}
                required
                onChange={(e) => {
                  setSelectedFechaFin2(e.target.value);
                  setFechaModificada(true);
                }}
              />
            </Col>
             <Col md={1}>
              <Label className="mr-sm-2">Meses Periodo 2</Label>
              <Input
                bsSize="sm"
                type="number"
                value={mesesPeriodo2}
                disabled
              />
            </Col>
            <Col md={2}>
            <h4></h4>
            <Button
              size="sm"
              className="btn"
              id="botonListado"
              onClick={BuscaInfo}
              color={fechaModificada ? "danger" : "info"}
            >
              Actualizar
            </Button>
          </Col>
          </Row>
      <Row>
            <Col md={2}>
              <Label>Marcas</Label>
              <Input
                bsSize="sm"
                type="select"
                value={selectedMarca}
                onChange={(e) => {
                  setSelectedMarca(e.target.value);
                  setCurrentPage(1);
                }}
              >
                <option value="0">Selecciona</option>
                {marcas
                  .sort((a, b) => (a.name > b.name ? 1 : -1))
                  .map((a) => {
                    return <option value={a._id}>{a.name}</option>;
                  })}
              </Input>
            </Col>
</Row>
          <br />
          <div className="table-wrapper">
          <Table size="sm" striped borderless className="table-responsive-xl">
            <TableHeader
              headers={headers}
              onSorting={(field, order) => setSorting({ field, order })}
            />
            <tbody>
              {commentsData.map((a) => {
                  return (
                    <tr>
                      <td>{a.SKU}</td>
                      <td>{a.nombre}</td>
                      <td>
                        {new Intl.NumberFormat("en-US").format(
                          a.cantidadPeriodo1
                        )}
                      </td>
                      <td>
                        {new Intl.NumberFormat("en-US", {
                          style: "currency",
                          currency: "USD",
                          maximumFractionDigits: 2,
                        }).format(a.precioPromedioBrutoPeriodo1)}
                      </td>
                      <td>
                        {new Intl.NumberFormat("en-US").format(
                          a.cantidadPeriodo1 / mesesPeriodo1
                        )}
                      </td>

                      <td>
                        {new Intl.NumberFormat("en-US").format(
                          a.cantidadPeriodo2
                        )}
                      </td>
                      <td>
                        {new Intl.NumberFormat("en-US", {
                          style: "currency",
                          currency: "USD",
                          maximumFractionDigits: 2,
                        }).format(a.precioPromedioBrutoPeriodo2)}
                      </td>
                      <td>
                        {new Intl.NumberFormat("en-US").format(
                          a.cantidadPeriodo2 / mesesPeriodo2
                        )}
                      </td>
                      <td>
                        {new Intl.NumberFormat("en-US", {
                          style: "currency",
                          currency: "USD",
                          maximumFractionDigits: 2,
                        }).format(a.precioPromedioNetoPeriodo2)}
                      </td>
                      <td>
                        {new Intl.NumberFormat("en-US").format(
                          a.margenBrutoPeriodo2
                        )}
                      </td>
                      <td>
  {mesesPeriodo1 > 0 && mesesPeriodo2 > 0 && a.cantidadPeriodo1 > 0 ? (
    new Intl.NumberFormat("en-US", {
      style: "percent",
      minimumFractionDigits: 2,
    }).format(
      ((a.cantidadPeriodo2 / mesesPeriodo2) - (a.cantidadPeriodo1 / mesesPeriodo1)) /
        (a.cantidadPeriodo1 / mesesPeriodo1)
    )
  ) : (
    "N/A"
  )}
</td>


                     <td>
  {a.precioPromedioBrutoPeriodo1 > 0 ? (
    new Intl.NumberFormat("en-US", {
      style: "percent",
      minimumFractionDigits: 2,
    }).format(
      ((a.precioPromedioBrutoPeriodo2 - a.precioPromedioBrutoPeriodo1) /
        a.precioPromedioBrutoPeriodo1)
    )
  ) : (
    "N/A"
  )}
</td>

<td>
                        {new Intl.NumberFormat("en-US").format(
                          a.inventarioMeli
                        )}
                      </td>
                      <td>
                        {new Intl.NumberFormat("en-US").format(
                          a.inventarioAmazon
                        )}
                      </td>
                      <td>
                        {new Intl.NumberFormat("en-US").format(
                          a.disponible
                        )}
                      </td>
                      <td>
                        {new Intl.NumberFormat("en-US").format(
                          a.inventarioMeli + a.inventarioAmazon + a.disponible
                        )}
                      </td>
                      <td>
                        {new Intl.NumberFormat("en-US").format(
                          a.porRecibir
                        )}
                      </td>

                      <td>
                        {new Intl.NumberFormat("en-US").format(
                          (a.inventarioMeli + a.inventarioAmazon + a.disponible) / (a.cantidadPeriodo2 / mesesPeriodo2)
                        )}
                      </td>

                      <td>
                        {new Intl.NumberFormat("en-US").format(
                          a.ventaUltimos30Dias
                        )}
                      </td>
                       <td>
                        {new Intl.NumberFormat("en-US", {
                          style: "currency",
                          currency: "USD",
                          maximumFractionDigits: 2,
                        }).format(a.precioPromedioNeto30Dias)}
                      </td>
                    </tr>
                  );
              })}
              {/* <tr>
                <td></td>
                <td></td>
                <td className="negrita">TOTAL</td>
                <td className="negrita">{new Intl.NumberFormat("en-US").format(totalTotalCantidad)}</td>
                <td></td>
                <td></td>
                <td className="negrita">{new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2}).format(totalTotalDineroBruto)}</td>
                <td className="negrita">{new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2}).format(totalTotalDinero)}</td>
              </tr> */}
            </tbody>
          </Table>
          </div>
          <div className="col-md-6">
            <Pagination
              total={totalItems}
              itemsPerPage={ITEMS_PER_PAGE}
              currentPage={currentPage}
              onPageChange={(page) => setCurrentPage(page)}
            />
          </div>
        </div>
      ) : undefined}
      <br />

      {loader}
    </>
  );
}

export default AnalisisGeneralProductos;
